import { AnimatePresence, motion } from 'framer-motion';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useGetBooksQuery } from '../features/books/bookAPISlice';
import { filtering } from '../features/books/filterBooks';
import BookCard from './BookCard';
import Loading from './Loading';

const Bookslist = () => {
    const{sort,search}=useSelector((state)=>state.filters);
    const dispath=useDispatch()

   

    const { data, isError, isLoading, isSuccess, error } = useGetBooksQuery();
    const [filterData,setFilterData]=useState([]);

    let content = null;

    useEffect(() => {
        setFilterData(filterFunc(data||[]))
    }, [data,sort,search])
    
    const filterFunc=(books)=>{

        let filterAllBooks=[...books]||[];


if(sort){
    filterAllBooks=filterAllBooks.filter(book=> (sort=='Featured' ? book.featured==true :book))
}
if(search){
    filterAllBooks=filterAllBooks.filter(book=> (book.name?.toLowerCase()?.includes(search?.toLowerCase())))

}

return filterAllBooks
    }

    
    
    if (isLoading) {
         content = <Loading />
    }
    if (!isLoading && isError && error) {
       content = <p>{error}</p>
    }
    if (filterData?.length ==0 && !isLoading ) {

         content = <p>No Books found</p>

    }
    if (filterData?.length > 0 && !isLoading) {
 

       content=
       <AnimatePresence>
{  filterData?.map(book=>(
        <BookCard key={book.id} book={book}/>
       ))}
       </AnimatePresence>
     

    }

console.log('search, sort', search, sort)

    return (

        <div className="order-2 xl:-order-1">
            <div className="flex items-center justify-between mb-12">
                <h4 className="mt-2 text-xl font-bold">Book List</h4>
                <div className="flex items-center space-x-4">
                    <button onClick={()=>dispath(filtering('All'))} className={`lws-filter-btn ${ sort=="All" && 'active-filter'}`}>All</button>
                    <button  onClick={()=>dispath(filtering('Featured'))}  className={`lws-filter-btn ${ sort=="Featured" && 'active-filter'}`} >   Featured</button>
                </div>
            </div>
            <motion.div layout className="space-y-6 md:space-y-0 md:grid grid-cols-1 lg:grid-cols-3 gap-6">
                {content}

            </motion.div>
        </div>

    )
}

export default Bookslist